webpackJsonp([20],{

/***/ 1029:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_manage_user_js__ = __webpack_require__(1143);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db5fc9cc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manage_user_vue__ = __webpack_require__(1340);
function injectStyle (ssrContext) {
  __webpack_require__(1338)
}
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_manage_user_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db5fc9cc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manage_user_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  uploadImage: function uploadImage(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'upload/v1/upload/image', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  isLogin: function isLogin(URL, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/signin', body).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addUser: function addUser(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/add/user', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  listUser: function listUser(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/list/user', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  removeUser: function removeUser(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/remove/user/code', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getRole: function getRole(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/list/role', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  userDetail: function userDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/get/user/code', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  userUpdate: function userUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/update/user/code', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  configDetail: function configDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/branch/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  confighUpdate: function confighUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/branch/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShift: function getHostShift(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'company/v1/host/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  companyDetail: function companyDetail(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'company/v1/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  companyUpdate: function companyUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  hostUpdate: function hostUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/host/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1082:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 1143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1053);

/* eslint-disable eqeqeq */

var header = {
  headers: {
    'Access-Token': sessionStorage.token
    // 'Access-Token': 'aca9457564ee48728a61c3d67d06e3e1'
  }
};
var residences = [{
  value: 'zhejiang',
  label: 'Zhejiang',
  children: [{
    value: 'hangzhou',
    label: 'Hangzhou',
    children: [{
      value: 'xihu',
      label: 'West Lake'
    }]
  }]
}, {
  value: 'jiangsu',
  label: 'Jiangsu',
  children: [{
    value: 'nanjing',
    label: 'Nanjing',
    children: [{
      value: 'zhonghuamen',
      label: 'Zhong Hua Men'
    }]
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      previewVisible: false,
      previewImage: '',
      filePic: '',
      fileList: [
        // {
        //   uid: '-1',
        //   name: 'xxx.png',
        //   status: 'done',
        //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
        // }
      ],
      confirmDirty: false,
      residences: residences,
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0
          },
          sm: {
            span: 16,
            offset: 8
          }
        }
      },
      roleList: [],
      user_data: null
    };
  },
  beforeCreate: function beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'register' });
  },

  methods: {
    testdata: function testdata() {
      console.log(this.password);
    },
    handleCancel: function handleCancel() {
      this.previewVisible = false;
    },
    handlePreview: function handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange: function handleChange(_ref) {
      var fileList = _ref.fileList;

      this.fileList = fileList;
    },
    handleSubmit: function handleSubmit(e) {
      var _this = this;

      e.preventDefault();
      this.form.validateFieldsAndScroll(function (err, values) {
        if (!err) {
          console.log('Received values of form: ', values);
          values.role_id = parseInt(values.role_id);
          if (_this.user_data != null) {
            values.user_code = _this.user_data.user_code;
            values.url_image = _this.filePic;
            values.company_id = 1;
            values.branch_id = 1;
            values.active_status = 1;
            _this.userUpdate(values);
          } else {
            _this.confirmData(values);
          }
        }
      });
    },
    handleConfirmBlur: function handleConfirmBlur(e) {
      var value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword: function compareToFirstPassword(rule, value, callback) {
      var form = this.form;
      if (value && value !== form.getFieldValue('password')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('รหัสผ่านไม่ตรงกัน');
      } else {
        callback();
      }
    },
    validateToNextPassword: function validateToNextPassword(rule, value, callback) {
      var form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true });
      }
      callback();
    },
    handleWebsiteChange: function handleWebsiteChange(value) {
      var autoCompleteResult = void 0;
      if (!value) {
        autoCompleteResult = [];
      } else {
        autoCompleteResult = ['.com', '.org', '.net'].map(function (domain) {
          return '' + value + domain;
        });
      }
      this.autoCompleteResult = autoCompleteResult;
    },
    confirmData: function confirmData(val) {
      var _this2 = this;

      this.$store.commit('Loading');
      console.log(val);
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].addUser(this.REST_URL, header, val, function (result) {
        console.log(result);
        if (result.response === 'success') {
          _this2.$notification['success']({
            message: 'เพิ่มข้อมูลผู้ใช้งานสำเร็จ',
            description: result.message
          });
          _this2.$router.push('manageusers');
        } else {
          _this2.$notification['warning']({
            message: 'ดึงข้อมูลลูกหนี้',
            description: result.message
          });
        }
        _this2.$store.commit('Loading');
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    userUpdate: function userUpdate(val) {
      var _this3 = this;

      this.$store.commit('Loading');
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].userUpdate(this.REST_URL, header, val, function (result) {
        console.log(result);
        if (result.response === 'success') {
          _this3.$notification['success']({
            message: 'แก้ไขข้อมูลผู้ใช้งานสำเร็จ',
            description: result.message
          });
          _this3.$router.push('/manageusers');
        } else {
          _this3.$notification['warning']({
            message: 'ดึงข้อมูลลูกหนี้',
            description: result.message
          });
        }
        _this3.$store.commit('Loading');
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    getRole: function getRole() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].getRole(this.REST_URL, {}, {}, function (result) {
        // console.log(result)
        if (result.response === 'success') {
          _this4.roleList = result.data;
        } else {
          _this4.$notification['warning']({
            message: 'ดึงข้อมูลลูกหนี้',
            description: result.message
          });
        }
        // this.$store.commit('Loading')
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    getUserDetail: function getUserDetail(val) {
      var _this5 = this;

      console.log(val);
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].userDetail(this.REST_URL, header, {
        'user_code': this.user_code
        // 'user_code': 'UID63011600001'
      }, function (result) {
        // console.log(result)
        if (result.response === 'success') {
          _this5.user_data = result.data;
          _this5.filePic = result.data.url_image;
          _this5.$nextTick(function () {
            _this5.form.setFieldsValue(result.data, ['name', 'register']);
          });
        } else {
          _this5.$notification['warning']({
            message: 'ดึงข้อมูลลูกหนี้',
            description: result.message
          });
        }
        // this.$store.commit('Loading')
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    uploadImgDefault: function uploadImgDefault() {
      var _this6 = this;

      var imagefile = document.querySelector('#imgDefault');
      if (imagefile.files.length > 0) {
        var formData = new FormData();
        formData.append('myFile', imagefile.files[0]);
        formData.append('type', 'product');
        __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].uploadImage(this.REST_URL, header, formData, function (result) {
          if (result.response === 'success') {
            _this6.filePic = result.data.url;
          } else {
            alert(result.message);
          }
        }, function (error) {
          alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
      }
    }
  },
  mounted: function mounted() {
    this.user_code = this.$route.params.user_code;
    console.log(this.user_code);
    this.getRole();
    if (this.user_code != '') {
      this.getUserDetail();
    }
  }
});

/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1339);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1017)("0fb25594", content, true, {});

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1016)(true);
// imports


// module
exports.push([module.i, ".ant-upload-select-picture-card i{font-size:100px;color:#999}.ant-upload-select-picture-card .ant-upload-text{margin-top:8px;color:#666}.ant-upload-list-picture-card .ant-upload-list-item{float:left;width:250px;height:250px;margin:0 8px 8px 0}.ant-upload.ant-upload-select-picture-card{display:table;width:250px;height:250px;margin-right:8px;margin-bottom:8px;text-align:center;vertical-align:top;background-color:#fafafa;border:1px dashed #d9d9d9;border-radius:4px;cursor:pointer;-webkit-transition:border-color .3s ease;transition:border-color .3s ease}.ant-form-item{-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;-webkit-font-feature-settings:\"tnum\";font-feature-settings:\"tnum\";margin-bottom:0;vertical-align:top}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/views/manage_user.vue"],"names":[],"mappings":"AA4IA,kCACE,gBAAiB,AACjB,UAAY,CACb,AACD,iDACE,eAAgB,AAChB,UAAY,CACb,AACD,oDACE,WAAY,AACZ,YAAa,AACb,aAAc,AACd,kBAAoB,CACrB,AACD,2CACE,cAAe,AACf,YAAa,AACb,aAAc,AACd,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,mBAAoB,AACpB,yBAA0B,AAC1B,0BAA2B,AAC3B,kBAAmB,AACnB,eAAgB,AAChB,yCAA2C,AAC3C,gCAAmC,CACpC,AACD,eACE,8BAA+B,AACvB,sBAAuB,AAC/B,SAAU,AACV,UAAW,AACX,sBAA2B,AAC3B,eAAgB,AAChB,0BAA2B,AAC3B,gBAAiB,AACjB,gBAAiB,AACjB,qCAAsC,AAC9B,6BAA8B,AACtC,gBAAmB,AACnB,kBAAoB,CACrB","file":"manage_user.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* you can make up upload button and sample style by using stylesheets */\n.ant-upload-select-picture-card i {\n  font-size: 100px;\n  color: #999;\n}\n.ant-upload-select-picture-card .ant-upload-text {\n  margin-top: 8px;\n  color: #666;\n}\n.ant-upload-list-picture-card .ant-upload-list-item {\n  float: left;\n  width: 250px;\n  height: 250px;\n  margin: 0 8px 8px 0;\n}\n.ant-upload.ant-upload-select-picture-card {\n  display: table;\n  width: 250px;\n  height: 250px;\n  margin-right: 8px;\n  margin-bottom: 8px;\n  text-align: center;\n  vertical-align: top;\n  background-color: #fafafa;\n  border: 1px dashed #d9d9d9;\n  border-radius: 4px;\n  cursor: pointer;\n  -webkit-transition: border-color 0.3s ease;\n  transition: border-color 0.3s ease;\n}\n.ant-form-item {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  -webkit-font-feature-settings: 'tnum';\n          font-feature-settings: 'tnum';\n  margin-bottom: 0px;\n  vertical-align: top;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mt-3",style:({ 'min-height' : _vm.$store.state.screenHeight - 100 + 'px' })},[_c('div',{staticClass:"card-body text-left"},[_c('div',{staticClass:"row",staticStyle:{"background-color":"#FF6161","display":"flex","justify-content":"left","align-items":"center"}},[_c('a-icon',{staticStyle:{"margin-right":"6px","font-size":"40px"},attrs:{"type":"user"}}),_vm._v(" "),_c('h1',{staticStyle:{"font-weight":"bold","margin":"5px"},on:{"click":function($event){return _vm.getUserDetail()}}},[_vm._v("ข้อมูลผู้ใช้งาน")])],1),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"background-color":"#ffffff"}},[_c('a-col',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"},attrs:{"span":8}},[_c('div',{staticClass:"upload-btn-wrapper",staticStyle:{"border":"1px dashed #adadad","border-radius":"5px"}},[(_vm.filePic == '')?_c('img',{attrs:{"src":__webpack_require__(1082),"width":"100%"}}):_vm._e(),_vm._v(" "),(_vm.filePic != '')?_c('img',{attrs:{"src":_vm.filePic,"width":"100%"}}):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"imgDefault"},on:{"change":_vm.uploadImgDefault}})])]),_vm._v(" "),_c('a-col',{staticStyle:{"background-color":"#ffffff","padding":"10px"},attrs:{"span":16}},[_c('a-form',{attrs:{"form":_vm.form},on:{"submit":_vm.handleSubmit}},[_c('a-form-item',_vm._b({},'a-form-item',_vm.formItemLayout,false),[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n              Username \n              "),_c('a-tooltip',{attrs:{"title":"What do you want others to call you?"}},[_c('a-icon',{attrs:{"type":"question-circle-o"}})],1)],1),_vm._v(" "),_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
                'username',
                {
                  rules: [{ required: true, message: 'กรุณากรอก UserName', whitespace: true }],
                } ]),expression:"[\n                'username',\n                {\n                  rules: [{ required: true, message: 'กรุณากรอก UserName', whitespace: true }],\n                },\n              ]"}]})],1),_vm._v(" "),_c('a-form-item',_vm._b({attrs:{"label":"ชื่อผู้ใช้งาน"}},'a-form-item',_vm.formItemLayout,false),[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
                'name',
                {
                  rules: [{ required: true, message: 'กรุณากรอกชื่อผู้ใช้งาน', whitespace: true }],
                } ]),expression:"[\n                'name',\n                {\n                  rules: [{ required: true, message: 'กรุณากรอกชื่อผู้ใช้งาน', whitespace: true }],\n                },\n              ]"}]})],1),_vm._v(" "),_c('a-form-item',_vm._b({attrs:{"label":"รหัสผ่าน"}},'a-form-item',_vm.formItemLayout,false),[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
                'password',
                {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณากรอกรหัสผ่าน',
                    },
                    {
                      validator: _vm.validateToNextPassword,
                    } ],
                } ]),expression:"[\n                'password',\n                {\n                  rules: [\n                    {\n                      required: true,\n                      message: 'กรุณากรอกรหัสผ่าน',\n                    },\n                    {\n                      validator: validateToNextPassword,\n                    },\n                  ],\n                },\n              ]"}],attrs:{"type":"password"}})],1),_vm._v(" "),_c('a-form-item',_vm._b({attrs:{"label":"ยืนยันรหัสผ่าน"}},'a-form-item',_vm.formItemLayout,false),[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
                'confirm',
                {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณากรอกรหัสผ่านอีกครั้ง',
                    },
                    {
                      validator: _vm.compareToFirstPassword,
                    } ],
                } ]),expression:"[\n                'confirm',\n                {\n                  rules: [\n                    {\n                      required: true,\n                      message: 'กรุณากรอกรหัสผ่านอีกครั้ง',\n                    },\n                    {\n                      validator: compareToFirstPassword,\n                    },\n                  ],\n                },\n              ]"}],attrs:{"type":"password"},on:{"blur":_vm.handleConfirmBlur}})],1),_vm._v(" "),_c('a-form-item',_vm._b({attrs:{"label":"เบอร์โทรศัพ"}},'a-form-item',_vm.formItemLayout,false),[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
                'telephone',
                {
                  rules: [{ required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' }],
                } ]),expression:"[\n                'telephone',\n                {\n                  rules: [{ required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' }],\n                },\n              ]"}]})],1),_vm._v(" "),_c('a-form-item',_vm._b({},'a-form-item',_vm.formItemLayout,false),[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n              ตำแหน่ง\n            ")]),_vm._v(" "),_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
                'role_id',
                { rules: [{ required: true, message: 'กรุณาเลือกตำแหน่ง!' }] } ]),expression:"[\n                'role_id',\n                { rules: [{ required: true, message: 'กรุณาเลือกตำแหน่ง!' }] },\n              ]"}]},_vm._l((_vm.roleList),function(d,i){return _c('a-select-option',{key:i,attrs:{"value":d.role_id}},[_vm._v("\n                "+_vm._s(d.role_name)+"\n              ")])}),1)],1),_vm._v(" "),_c('a-form-item',_vm._b({},'a-form-item',_vm.tailFormItemLayout,false),[_c('a-button',{attrs:{"type":"primary","html-type":"submit"}},[_vm._v("\n              บันทึก\n            ")])],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/20.cadbf7a2ccecf70fb269.js